<!-- input 输入框 -->
<template>
  <input
    v-bind="getBindValue"
  >
</template>

<script lang="ts" setup>
import { computed, useAttrs, nextTick } from 'vue'
import { nicknameInputProps } from './props'

/* data 数据 */
const props = defineProps(nicknameInputProps)
const attrs = useAttrs()
const emits = defineEmits(['update:modelValue'])
const getBindValue = computed(() => ({
  class: props.textAlign === 'left' ? 'text-left' : 'text-right',
  value: props.modelValue,
  type: 'nickname',
  onBlur: async e => {
    const value = e.detail.value.slice(0, props.maxLength)
    if (value === props.modelValue) {
      emits('update:modelValue', e.detail.value)
      await nextTick()
    }
    emits('update:modelValue', value)
  },
  ...attrs
}))

</script>